import { Component } from '@angular/core';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-microchipping-your-pet-wrapper',
  template: `
    <app-microchipping-your-pet-v2 *ngIf="useRebranded"></app-microchipping-your-pet-v2>
    <app-microchipping-your-pet *ngIf="!useRebranded"></app-microchipping-your-pet>
  `
})
export class MicrochippingYourPetWrapperComponent {
  public useRebranded: boolean;

  constructor(private featureFlagService: FeatureFlagsService) {
    this.useRebranded = this.featureFlagService.isEnabled('useRebrandedLayout');
  }
}
